import { render } from "./PromptPage.vue?vue&type=template&id=696b03da&scoped=true&ts=true"
import script from "./PromptPage.vue?vue&type=script&lang=ts"
export * from "./PromptPage.vue?vue&type=script&lang=ts"

import "./PromptPage.vue?vue&type=style&index=0&id=696b03da&lang=scss&scoped=true"

import exportComponent from "E:\\vue_test\\form-gpt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-696b03da"]])

export default __exports__